import React, { FC, useCallback } from "react";
import { TableInfoDc, ResourceTypeLink, ServiceInfoDc } from "@evergis/api";
import { useTranslation } from "react-i18next";
import { useResourceSelectorContext } from "../../../../components/ResourceSelector/ResourceSelector";

import { CardControls } from "../CardControls/CardControls";
import { CardContent } from "./CardContent";

import { useNewLayerFromData } from "../../../../hooks/useDialogs";
import { useTablePreviewUrl } from "../../../../hooks/preview/usePreviewUrl";
import { useLimitsExceededCheck } from "../../../../hooks/useLimitsExceededCheck";

import { CardProps } from "./Card";

export const TableCard: FC<CardProps<TableInfoDc>> = ({ resource }) => {
  const { t } = useTranslation("catalog");
  const preview = useTablePreviewUrl(resource.name);
  const processedCreateLayer = useLimitsExceededCheck(useNewLayerFromData());
  const {
    onSelect: onResourceSelect,
    active: layerSelectorActive,
    selectedResourceName,
  } = useResourceSelectorContext();

  const onLayerSelect = useCallback(() => {
    onResourceSelect(resource as ServiceInfoDc);
  }, [onResourceSelect, resource]);

  const onLayerCreate = useCallback(
    () => processedCreateLayer([resource.name, ResourceTypeLink.Layer]),
    [processedCreateLayer, resource.name],
  );

  return (
    <CardContent
      resource={resource}
      preview={preview}
      disabled={layerSelectorActive && selectedResourceName === resource.name}
      applyLabel={
        layerSelectorActive
          ? selectedResourceName === resource.name
            ? t("selected", { ns: "catalog" })
            : t("actions.select", { ns: "common" })
          : t("newLayer")
      }
      onOpen={layerSelectorActive ? onLayerSelect : onLayerCreate}
    >
      <CardControls
        resource={resource}
        config={{
          infoIcon: {
            title: t("tableInfo"),
          },
        }}
      />
    </CardContent>
  );
};
